import { render, staticRenderFns } from "./OrganizationCampaigns.vue?vue&type=template&id=cb92cc6c&"
import script from "./OrganizationCampaigns.vue?vue&type=script&lang=js&"
export * from "./OrganizationCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationCampaigns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports